import script from "./registerSjNoPassList.vue?vue&type=script&setup=true&lang=js"
export * from "./registerSjNoPassList.vue?vue&type=script&setup=true&lang=js"

import "./registerSjNoPassList.vue?vue&type=style&index=0&id=6de829de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de829de"]])

export default __exports__